module.exports = __webpack_public_path__ + "img/multihull--white.bc6d8606.svg";